// extracted by mini-css-extract-plugin
export default {"marginInputBottom":"Withdraw_marginInputBottom__9dUAZ"};